import { render, staticRenderFns } from "./bscdown.vue?vue&type=template&id=edc964c6&"
import script from "./bscdown.vue?vue&type=script&lang=js&"
export * from "./bscdown.vue?vue&type=script&lang=js&"
import style0 from "./bscdown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports